import { render } from "./AccountingMain.vue?vue&type=template&id=5a84fab2&scoped=true"
import script from "./AccountingMain.vue?vue&type=script&lang=js"
export * from "./AccountingMain.vue?vue&type=script&lang=js"

import "./AccountingMain.vue?vue&type=style&index=0&id=5a84fab2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a84fab2"]])

export default __exports__